"use client";

import Image from "next/image";
import OrganisationCategories from "./org-categories";
import Skeleton from "react-loading-skeleton";
import Pagination from "../common/Pagination";
import styles from "./index.module.css";
import { useState } from "react";

const OrgList = ({
  handleSwitch,
  orgState,
  openPage,
  token,
  isLoading,
  isFetching,
  currentOrg = null,
}) => {
  const [imageLoadedMap, setImageLoadedMap] = useState({});
  const handleImageLoad = (orgId) => {
    setImageLoadedMap((prev) => ({ ...prev, [orgId]: true }));
  };

  // support currentOrg being either an object ({ orgId }) or just an id value
  const currentOrgId = currentOrg ? currentOrg.orgId ?? currentOrg : null;

  // filter out the current organisation from the list
  const visibleOrgs = (orgState.organisations || []).filter(
    (org) => org.orgId !== currentOrgId
  );

  return (
    <>
      <div className={styles.marketPlaceOrganisations}>
        {visibleOrgs.map((org) => {
          const isLoaded = imageLoadedMap[org.orgId];
          return (
            <div
              key={org.orgId}
              className={styles.organisation}
              onClick={() => handleSwitch(org)}
            >
              <div className={styles.organisationInfo}>
                {!org.logoUrl && (
                  <div className={styles.organisationPlaceholderLogo}>
                    {org.orgName?.[0]?.toUpperCase() || "?"}
                  </div>
                )}
                {org.logoUrl && (
                  <div>
                    {!isLoaded && <Skeleton width={70} height={70} circle />}
                    {isLoaded && (
                      <Image
                        src={org.logoUrl}
                        alt={`${org.orgName} logo`}
                        width={70}
                        height={70}
                        className={styles.organisationLogo}
                        style={{
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                    )}
                    <img
                      src={org.logoUrl}
                      alt={org.orgName}
                      style={{ display: "none" }}
                      onLoad={() => handleImageLoad(org.orgId)}
                    />
                  </div>
                )}
                <div className={styles.textInfo}>
                  <p className={styles.organisationName}>
                    {org.orgName
                      .split(" ")
                      .map(
                        (word) =>
                          word.charAt(0).toUpperCase() +
                          word.slice(1).toLowerCase()
                      )
                      .join(" ")}
                  </p>
                  <p className={styles.organisationDescription}>
                    {org.description || "No description available."}
                  </p>
                </div>
              </div>
              <div className={styles.organisationCategories}>
                <OrganisationCategories
                  org={org}
                  token={token}
                  handleSwitch={handleSwitch}
                />
              </div>
            </div>
          );
        })}
      </div>
      <Pagination
        infiniteScroll={true}
        total={orgState.total}
        limit={orgState.limit}
        page={orgState.page}
        onPageClick={openPage}
        enableManualMode={true}
        autoLoadThreshold={5}
        isLoading={isLoading}
        isFetching={isFetching}
        showEndOfList={true}
        endOfListText="🎉 You've reached the end!"
      />
    </>
  );
};
export default OrgList;
